import type { ReactNode } from 'react';
import { RecordPicker } from '../../components/RecordPicker.js';

interface AppOption {
  readonly applicationId: string;
  readonly appCode: string;
  readonly appName: string;
}

interface Props {
  readonly label: string;
  readonly value: string;
  readonly onPick: (id: string) => void;
  readonly testId?: string;
}

/** Application chooser shared by the M40 designer screens. */
export function AppPicker({ label, value, onPick, testId = 'field-application-id' }: Props): ReactNode {
  return (
    <RecordPicker<AppOption>
      endpoint="/v1/app-platform/applications?pageSize=500"
      idField="applicationId"
      label={label}
      testId={testId}
      value={value}
      optionLabel={(a) => `${a.appName} (${a.appCode})`}
      onPick={onPick}
      emptyText="No applications yet"
    />
  );
}
